<template>
    <div class="service-modal show" v-if="isVisible">
        <div class="modal-mbway-container">
            <div class="modal-mbway">
                <div class="row">

                    <h3 class="text-orange text-center my-3">a aguardar pagamento por mbway</h3>
                    <p class="sub-title">Por favor, confirma o pagamento para completares a tua encomenda</p>

                    <div class="mbway-content">
                        <img :src="mbwayIco" alt="mb way">
                        <p>faltam {{timeDisplay}}</p>
                    </div>

                    <div class="col-md-12 text-center">
                        <button class="btn-text-only" @click="close">
                            Alterar método de pagamento
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ic_mbway from '../../svg/ic_mbway.svg'
    export default {
    props: {

    },
    data() {
        return {
            isVisible: false,
            timeDisplay: '',
            timerInterval: null,
            code: null,
            mbwayIco: ic_mbway
        }
    },
    created() {
        this.$root.$on('display-modal-mbway-payment', (code) => {
            this.isVisible = true;
            this.code = code;
            this.beginTimer();
            document.querySelector('html').classList.add('no-scroll');
            document.querySelector('body').classList.add('no-scroll');
        });

    },
    methods: {
        beginTimer() {
            let seconds = 59, min = 4;
            this.timerInterval = setInterval(() => {
                if(--seconds == -1){
                    --min;
                    seconds = 59;
                }

                if(min + seconds <= 0)
                    this.performErrorLogic();

                if(seconds % 30 == 0 || seconds == 0)
                    this.checkPaymentStatus();

                let s = seconds < 10 ? `0${seconds}` : `${seconds}`;
                this.timeDisplay = `0${min}:${s}`;
            }, 1000);
        },
        checkPaymentStatus() {
            this.$axios.get(`/order/${this.code}/payment/status`)
            .then((response) => {
                if(response.data.error)
                    this.performErrorLogic();
                if(response.data.paid){
                    Livewire.emit('redirectPaymentSuccess');
                    this.close();
                }
            }).catch((error) => {
                this.performErrorLogic();
            });
        },
        performErrorLogic() {
            this.close();
            this.$root.$emit('display-modal-error-payment');
        },
        close() {
            clearTimeout(this.timerInterval);
            this.isVisible = false;
            document.querySelector('html').classList.remove('no-scroll');
            document.querySelector('body').classList.remove('no-scroll');
        }
    }
}

</script>

<style>

</style>
